import * as queries from './common/services/queries';
import { versionStatus } from './common/services/client';




export function buildExpressions({ search, settings }) {
	switch (settings.appId) {
		case 'search':
			return buildSearchExpressions({ search, settings });
		case 'events':
			return buildEventsExpressions({search, settings});
		case 'news':
			return buildNewsExpressions({search, settings});
		case 'ourstories':
			return buildOurStoriesExpressions({search, settings});
		case 'insights':
			return buildInsightsExpressions({search, settings});
		case 'careers':
			return buildCareersExpressions({search, settings});
		case 'atoz':
			return buildAtoZExpressions({search, settings});
		case 'IMReportsGridAppId':
		case 'IMReportsListerAppId':
			return buildIMReportsListerExpressions({search, settings});
		case 'JIPLister':
			return buildJIPListerExpressions({search, settings});
		case 'PublishedPapersLister':
			return buildPublishedPapersContentTypeExpressions({search, settings});
		case 'CSWIPSchemesAppId':
			return buildCSWIPSchemesContentTypeExpressions({search, settings});
		case 'CSWIPSearchAppId':
			return buildCSWIPSearchExpressions({ search, settings });
		case 'CSWIPNewsAppId':
			return buildCSWIPNewsExpressions({search, settings});
		case 'CSWIPInsightsAppId':
			return buildCSWIPInsightsExpressions({search, settings});
		case 'TWIInnovationNetworkNewsAppId':
			return buildTWIInnovationNetworkNewsExpressions({search, settings});
		case 'memberListAppId':
			return buildMemberListExpressions({search, settings});
		case 'TWIInnovationNetworkEventsAppId':
			return buildTWIInnovationNetworkEventsExpressions({search, settings});
		case 'TWIInnovationNetworkSearchAppId':
			return buildTWIInnovationNetworkSearchExpressions({ search, settings });
		case 'PublicFundedProjectsListerAppId':
			return buildPublicFundedProjectsListerExpressions({search, settings});
		case 'CoreResearchProgrammeListerAppId':
				return buildCoreResearchProgrammeListerExpressions({search, settings});
		case 'FAQListerAppId':
				return buildFAQListerExpressions({search, settings});
		case 'TWIDEInsightsAppId':
				return buildTWIDEInsightsExpressions({search, settings});
		case 'JobKnowledgeListerAppId':
				return buildJobKnowledgeListerExpressions({search, settings});
		case 'NSIRCNewsAppId':
			return buildNSIRCNewsExpressions({search, settings});
		case 'NSIRCPublicationsAppId':
			return buildNSIRCPublicationsExpressions({search, settings});
		case 'NSIRCThesesAppId':
			return buildNSIRCThesesExpressions({search, settings});
		case 'NSIRCDissertationsAppId':
			return buildNSIRCDissertationsExpressions({search, settings});
		case 'NSIRCStudentProfilesAppId':
			return buildNSIRCStudentProfilesExpressions({search, settings});
		case 'NSIRCInsightsAppId':
			return buildNSIRCInsightsExpressions({search, settings});
		case 'NSIRCCareersAppId':
			return buildNSIRCCareersExpressions({search, settings});
		case 'NSIRCSearchAppId':
			return buildNSIRCSearchExpressions({search, settings});	
		case 'OurPeopleAppId':
			return buildOurPeopleExpressions({search, settings});	
		case 'GenericPressReleasesAppId':
			return buildGenericPressReleasesExpressions({search, settings});
		case 'GenericShowcaseAppId':
			return buildGenericShowcaseExpressions({search, settings});
		case 'TWICLCertificationsAppId':
			return buildTWICLCertificationsExpressions({search, settings});
		case 'TWICLCompaniesAppId':
			return buildTWICLCompaniesExpressions({search, settings});
		case 'CTLFAQListerAppId':
			return buildCTLFAQListerExpressions({search, settings});
		case 'GenericInsightsAppId':
			return buildGenericInsightsExpressions({search, settings});
		case 'GenericSearchAppId':
			return buildGenericSearchExpressions({ search, settings });
		case 'GenericWebpageListerAppId':
			return buildGenericWebpageListerExpressions({ search, settings });
		case 'DigitalProductFinderAppId':
			return buildDigitalProductFinderExpressions({ search, settings });
		case 'TWIJobsAppId':
			return buildTWIJobsExpressions({ search, settings });
		case 'TWIInnovationNetworkTAPsAppId':
			return buildTWIInnovationNetworkTAPsExpressions({ search, settings });
		case 'GenericVideosAppId':
			return buildGenericVideosExpressions({ search, settings });
		case 'VirtualAcademyAppId':
			return buildVirtualAcademyExpressions({search, settings});
		default:	
			return buildDefaultExpressions({ search, settings });
		
	}
}

function buildSearchExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.searchAll(),
		...queries.authorSearch(search),
		...queries.sortOrder(search),
		...queries.filterUserGroupContent(settings),
		...queries.includeInSearch(),
		...queries.searchWeldasearch(search),
		...queries.excludeFromSearch()
	];
}
function buildOurStoriesExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.standardDateFilters(search.date)
	];
}
function buildInsightsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.publishDateFilters(search.date),
		...queries.hideFromCorporate()
	];
}




function buildCareersExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.notNSIRCVacancies()
	];
}
function buildNewsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.hideFromCorporate(),
		...queries.newsDateFilters(search.date)
	];
}
function buildEventsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.showEventOnCorporate(settings.microsite),
		...queries.getPrivateEvents(settings.companyName),
		// ...queries.getMicrositeEvents(settings.microsite),
		...queries.orderBy()
	];
}
function buildAtoZExpressions({ search}) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.pathStartsWith('/what-we-do/research-and-technology/technologies/'),
		...queries.startWith(search.startWith)
	];
}
function buildDefaultExpressions({ settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.includeInSearch()
	];
}
function buildIMReportsListerExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		// ...queries.pathStartsWith('/what-we-do/research-and-technology/research-reports/industrial-member-reports/'),
		...queries.pathStartsWith('/what-we-do/research-and-technology/research-programmes/core-research-programme/report-abstracts/'),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.pageDateYearFilter(search.date),
		...queries.excludeHomePage(),

	];
}
function buildJIPListerExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		// ...queries.dateAnnouncedFilter(search.date),
		// ...queries.sortOrder(search),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.projectStatus(search.status)
	];

}
function buildPublishedPapersContentTypeExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.excludeHomePage(),
		...queries.pageDateFilter(search.date)
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}
function buildCSWIPSchemesContentTypeExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.pageDateFilter(search.date),
		...queries.certificationFilter(search.schemetype, settings.microsite, settings.certificationFilter)
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}
function buildCSWIPSearchExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.cswipContentType(),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.pageDateFilter(search.date),
		// ...queries.cswipSearch()
		//...queries.pathStartsWith('/microsites/cswip/'),
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}
function buildCSWIPNewsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeNews("CSWIP"),
		...queries.newsDateFilters(search.date)
	];
}
function buildCSWIPInsightsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeInsights("CSWIP"),
		...queries.newsDateFilters(search.date)
	];
}
function buildTWIInnovationNetworkNewsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeNews("TWIInnovationNetwork"),
		...queries.newsDateFilters(search.date)
	];
}
function buildMemberListExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
	];
}
function buildTWIInnovationNetworkEventsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeEvents("TWIInnovationNetwork"),
		...queries.orderBy()
	];
}
function buildTWIInnovationNetworkSearchExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.twiinContentType(),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.pageDateFilter(search.date),
		//...queries.pathStartsWith('/microsites/twi-innovation-network/'),
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}
function buildPublicFundedProjectsListerExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.dateAnnouncedFilter(search.date),
		...queries.sortOrder(search),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.hideFromCorporate()
	];
}
function buildCoreResearchProgrammeListerExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.excludeHomePage(),
		...queries.pageDateYearFilter(search.date),
		...queries.pathStartsWith('/what-we-do/research-and-technology/research-programmes/core-research-programme/executive-summaries/')
		//...queries.pathStartsWith('/what-we-do/research-and-technology/current-research-programmes/twi-core-research')
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])] 	

	];
}

function buildFAQListerExpressions({ search, settings }) {	
	return [

		
		...queries.versionStatus(versionStatus),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.FAQQuery(search.term,settings.microsite)


		// // ...queries.excludeHomePage(),
		// ...queries.pageDateFilter(search.date),
		// // ...queries.searchCurrentDir(),
		// ...queries.hideFromListingPage()
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}

function buildCTLFAQListerExpressions({ search, settings }) {	
	return [

		
		...queries.versionStatus(versionStatus),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.FAQQuery(search.term,settings.microsite)


		// // ...queries.excludeHomePage(),
		// ...queries.pageDateFilter(search.date),
		// // ...queries.searchCurrentDir(),
		// ...queries.hideFromListingPage()
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}


function buildTWIDEInsightsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeInsights("TWIDeutschland"),
		...queries.newsDateFilters(search.date)
	];
}
function buildJobKnowledgeListerExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.excludeHomePage(),
		...queries.pageDateFilter(search.date),
		...queries.pathStartsWith('/technical-knowledge/job-knowledge')
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];

}

function buildNSIRCNewsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeNews("NSIRC_news"),
		...queries.newsDateFilters(search.date)
	];
}

function buildNSIRCPublicationsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeNews("NSIRC_publications"),
		...queries.newsDateFilters(search.date)
	];
}

function buildNSIRCThesesExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeNews("NSIRC_theses"),
		...queries.newsDateFilters(search.date)
	];
}

function buildNSIRCDissertationsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeNews("NSIRC_dissertations"),
		...queries.newsDateFilters(search.date)
	];
}

function buildNSIRCStudentProfilesExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeNews("NSIRC_students"),
		...queries.newsDateFilters(search.date)
	];
}
function buildNSIRCInsightsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeNews("NSIRC_insights"),
		...queries.newsDateFilters(search.date)
	];
}
function buildNSIRCCareersExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.NSIRCVacancies()
	];
}
function buildNSIRCSearchExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.pageDateFilter(search.date),
		...queries.nsircSearch()
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}
function buildOurPeopleExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.ourPeopleFilter(),
		// ...queries.filters(search, settings.taxonomyFilters),
		// ...queries.newsDateFilters(search.date)
	];
}
function buildGenericPressReleasesExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		// ...queries.filters(search, settings.taxonomyFilters),
		...queries.getMicrositeNews(settings.microsite),
		...queries.newsDateFilters(search.date)
	];
}
function buildGenericShowcaseExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		// ...queries.filters(search, settings.taxonomyFilters),
		...queries.getShowcase(settings.showcaseCollection),
		...queries.newsDateFilters(search.date)
	];
}

function buildTWICLCertificationsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.pageDateFilter(search.date),
		...queries.certificationFilter(search.schemetype, settings.microsite, settings.certificationFilter)
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}

function buildTWICLCompaniesExpressions({ search, settings }) {	

	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		//...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.certifiedCompanyFilter(search.certificationtype),
		//...queries.orderBy('companyName')
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];



	// if (Object.keys(search) > 0 ) {
	// 	return [
	// 		...queries.versionStatus(versionStatus),
	// 		...queries.contentType(settings.contentTypeId),
	// 		...queries.weightedSearchTerm(search.term, settings.weightedFields),
	// 		...queries.pageDateFilter(search.date),
	// 		...queries.companyCertificationFilter(search.certificationtype)
	// 		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
	// 		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	// 	];
	// } 

	// return [];

}


function buildGenericInsightsExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.filters(search, settings.taxonomyFilters),
		...queries.publishDateFilters(search.date),
		...queries.getGenericInsights(settings.microsite),
	//	...queries.hideFromCorporate()
	];
}

function buildGenericSearchExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.genericSearchContentType(settings),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		//...queries.pageDateFilter(search.date),
		//...queries.includeInSearch() - pages are created with includeInSearch as false by default
		// ...queries.cswipSearch()
		//...queries.pathStartsWith('/microsites/cswip/'),
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}

function buildGenericWebpageListerExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.excludeHomePage(),
		...queries.pageDateYearFilter(search.date),
		...queries.pathStartsWith(settings.baseUri)
		//...queries.orPathEndsWith('/technical-knowledge/published-papers/')
		//,...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}


function buildDigitalProductFinderExpressions({ search, settings }) {	
	return [

		
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		
		// ...queries.filters(search, settings.taxonomyFilters),
		// ...queries.FAQQuery(search.term,settings.microsite)


		// ...queries.excludeHomePage(),
		// ...queries.pageDateFilter(search.date),
		// ...queries.searchCurrentDir(),
		// ...queries.hideFromListingPage(),
		// ...queries.orPathEndsWith('/technical-knowledge/published-papers/'),
		// ...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}



function buildTWIJobsExpressions({ search, settings }) {

	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.twiJobsFilters(search),
		...queries.datePostedFilter(search.datePosted),

	];
}


function buildTWIInnovationNetworkTAPsExpressions({ search, settings }) {

	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.TAPsFilter(search),
		//...queries.datePostedFilter(search.datePosted),
	
		// ...queries.orPathEndsWith('/technical-knowledge/published-papers/'),
		// ...queries[Op.or([{'field': 'uri', 'startsWith': '/technical-knowledge/published-papers/'}])]
	];
}


function buildGenericVideosExpressions({ search, settings }) {

	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.getVideos(settings.microsite),
	];
}


function buildVirtualAcademyExpressions({ search, settings }) {	
	return [
		...queries.versionStatus(versionStatus),
		...queries.contentType(settings.contentTypeId),
		...queries.weightedSearchTerm(search.term, settings.weightedFields),
		...queries.getVirtualAcademy(),

	];
}

	